import Noty from "noty";
// For cable channels updates and flash_messages_controller.js
window.flash_message = (text, type) => {
  return new Noty({
    text: `<span role="alert">${text}</div>`,
    type: type,
    theme: "bkpan",
    timeout: 3500
  })
}